export default class PriorityTargetDto {
    serialNumber;
    grade;
    classNumber;
    number;
    name;
    termId;
    listId;
    itemId;
    currentGrading;
    targetGrading;
    approachScene;
    howToApproach;
  
    constructor(data) {
      this.serialNumber = data.serialNumber;
      this.grade = data.grade;
      this.classNumber = data.classNumber;
      this.number = data.number;
      this.name = data.name;
      this.termId = data.termId;
      this.listId = data.listId;
      this.itemId = data.itemId;
      this.currentGrading = data.currentGrading;
      this.targetGrading = data.targetGrading;
      this.approachScene = data.approachScene;
      this.howToApproach = data.howToApproach;
    }
  }
  